/**
 * Archetype Self-Selection
 * Handles "This Is Me" button on archetype detail pages.
 * Logged-in: POST to worker /archetype/select
 * Guest: Store in localStorage, sync on next wishlist add
 */
(function() {
  'use strict';

  var WORKER_URL = 'https://api.parfumcentral.com';
  var WORKER_API_KEY = 'c8190abe180155ef22c00c8ba7761b9d';
  var STORAGE_KEY = 'pc_pending_archetype';

  function getCustomer() {
    var data = window.dataLayer && window.dataLayer.find(function(d) { return d.customerEmail !== undefined; });
    if (data && data.customerLoggedIn && data.customerEmail) {
      return { email: data.customerEmail, loggedIn: true };
    }
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId) {
      var meta = document.querySelector('meta[name="customer-email"]');
      if (meta && meta.content) return { email: meta.content, loggedIn: true };
    }
    if (window.__st && window.__st.cid) {
      var meta2 = document.querySelector('meta[name="customer-email"]');
      if (meta2 && meta2.content) return { email: meta2.content, loggedIn: true };
    }
    return { email: null, loggedIn: false };
  }

  var btn = document.getElementById('archetype-select-btn');
  if (!btn) return;

  var archetype = btn.dataset.archetype;
  if (!archetype) return;

  // Check if already selected (localStorage)
  try {
    var stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (stored && stored.archetype === archetype) {
      showSuccess();
    }
  } catch (e) { /* ignore */ }

  btn.addEventListener('click', function() {
    if (btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Saving...';

    var customer = getCustomer();

    if (customer.loggedIn && customer.email) {
      // Logged in — POST to worker
      fetch(WORKER_URL + '/archetype/select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-API-Key': WORKER_API_KEY },
        body: JSON.stringify({ email: customer.email, archetype: archetype })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.success) {
          localStorage.setItem(STORAGE_KEY, JSON.stringify({
            archetype: data.archetype || archetype,
            source: data.source || 'self-selected',
            synced: true
          }));
          showSuccess();
        } else {
          btn.textContent = 'This Is Me';
          btn.disabled = false;
        }
      })
      .catch(function() {
        // Fallback: store locally even if API fails
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          archetype: archetype,
          source: 'self-selected',
          selectedAt: new Date().toISOString(),
          synced: false
        }));
        showSuccess();
      });
    } else {
      // Guest — store in localStorage
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        archetype: archetype,
        source: 'self-selected',
        selectedAt: new Date().toISOString(),
        synced: false
      }));
      showSuccess();
    }
  });

  function showSuccess() {
    var btns = document.getElementById('archetype-cta-buttons');
    var success = document.getElementById('archetype-cta-success');
    if (btns) btns.style.display = 'none';
    if (success) {
      success.style.display = 'block';
      success.style.animation = 'ap-pulse 0.3s ease';
    }
  }
})();
